<template>
	<i class="icon icon-manutencao_motor"></i>
</template>

<script>
export default {}
</script>
